// Filled in by esbuild.
declare const REPLICACHE_VERSION: string;

/**
 * The current version of Replicache.
 */
export const version: string = REPLICACHE_VERSION;
